import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
  DroppableProvided,
} from "@hello-pangea/dnd";
import { Task } from "../../lib/api/tasks";
import { TaskCard } from "./TaskCard";

export const COLUMNS = {
  TODO: {
    title: "To Do",
    className: "bg-gray-100",
  },
  IN_PROGRESS: {
    title: "In Progress",
    className: "bg-blue-50",
  },
  IN_REVIEW: {
    title: "In Review",
    className: "bg-yellow-50",
  },
  DONE: {
    title: "Done",
    className: "bg-green-50",
  },
} as const;

interface KanbanBoardProps {
  tasksByStatus: Record<string, Task[]>;
  onDragEnd: (result: DropResult) => void;
  onTaskClick: (task: Task) => void;
}

export function KanbanBoard({
  tasksByStatus,
  onDragEnd,
  onTaskClick,
}: KanbanBoardProps) {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="grid grid-cols-4 gap-4">
        {Object.entries(COLUMNS).map(([status, { title, className }]) => (
          <div key={status} className={`${className} rounded-lg p-4`}>
            <h3 className="font-semibold mb-4">{title}</h3>
            <Droppable droppableId={status}>
              {(provided: DroppableProvided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className="space-y-4"
                >
                  {(tasksByStatus[status] || []).map((task, index) => (
                    <Draggable
                      key={task._id}
                      draggableId={task._id}
                      index={index}
                    >
                      {(provided) => (
                        <TaskCard
                          task={task}
                          provided={provided}
                          onClick={() => onTaskClick(task)}
                        />
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        ))}
      </div>
    </DragDropContext>
  );
}
